import { useDeferApi } from "@core-ui/hooks/useApi";
import AgentSkillService from "@ext/agent/components/skills/AgentSkillService";
import type { ProviderItemProps } from "@ext/articleProvider/models/types";
import { useCallback } from "react";

const SKILL_FETCH_OPTS = { consumeError: true } as const;

const isNamed = (skill: ProviderItemProps, skillName: string) => skill.title === skillName || skill.id === skillName;

export const useOpenAgentSkill = () => {
	const { skills } = AgentSkillService.value;
	const { call: fetchSkillItems } = useDeferApi<ProviderItemProps[]>({ opts: SKILL_FETCH_OPTS });

	return useCallback(
		async (skillName: string) => {
			let skill = Array.from(skills.values()).find((s) => isNamed(s, skillName));

			if (!skill) {
				const items = await fetchSkillItems({ url: (api) => api.getArticleListInGramaxDir("agentSkill") });
				if (items) {
					AgentSkillService.setItems(items);
					skill = items.find((s) => isNamed(s, skillName));
				}
			}

			if (skill) AgentSkillService.openItem(skill);
		},
		[skills, fetchSkillItems],
	);
};
